'use client';
import { useEffect, useState } from 'react';
import { freeProductRuleList } from './apis';
import ListCard from './ListCard';
import MoreBtn from './MoreBtn';
import CreditsLine from './CreditsLine';
import getLocal from '@/app/utils/getLocal';
export default function TabContentB({ creditsData, winCallback, itemCallback }: any) {
    const { locale } = getLocal();
    const [listA, setListA] = useState([]);
    useEffect(() => {
        const initFn = async () => {
            const res = await freeProductRuleList(locale);
            if (res.code === '0') {
                setListA(res.data || []);
            }
        };
        initFn();
    }, []);
    return (
        <>
            <div className="eco-redeem-rewards-more-box">
                <CreditsLine creditsData={creditsData} />
                <MoreBtn winCallback={winCallback} />
            </div>
            <div className="eco-redeem-rewards-list">
                {listA.map((item: any, index: number) => {
                    return (
                        <div className={`eco-redeem-rewards-item eco-redeem-rewards-item-${index + 1}`} key={index}>
                            <ListCard creditsData={creditsData} data={item} locale={locale} itemCallback={itemCallback} tabType="tabB" />
                        </div>
                    );
                })}
            </div>
        </>
    );
}
